import { strDate } from '@/utils/function';
import React from 'react';
import { useTranslation } from 'react-i18next';

type P = {
  docId: string;
  subject: string;
  author: {
    name: string;
    positionName: string;
  };
  authoredAt: string;
  createdAt?: string;
  sendPostMessage: (docId: string) => void;
};

const RecentContent = ({
  docId,
  subject,
  author,
  authoredAt,
  createdAt,
  sendPostMessage,
}: P) => {
  const { t } = useTranslation();

  const handleOpen = () => {
    sendPostMessage(docId);
  };

  return (
    <>
      <button
        style={{ fontSize: '14px', textAlign: 'left', padding: '0' }}
        onClick={handleOpen}
      >
        <div
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            lineHeight: '20px',
          }}
        >
          {subject}
        </div>
        <div style={{ display: 'flex', marginTop: '4px' }}>
          <div style={{ color: 'var(--dk-text-dim, #B7BBC2)', lineHeight: '20px' }}>
            {strDate(t, authoredAt || createdAt)}
          </div>
          <div
            style={{
              width: '1px',
              background: 'var(--dk-bg-strong, #E7E9EC)',
              margin: '2px 8px',
            }}
          />
          <div
            style={{ color: 'var(--dk-text-secondary, #888D96)', lineHeight: '20px' }}
          >{`${author.name} ${author.positionName}`}</div>
        </div>
      </button>
    </>
  );
};

export default RecentContent;
